import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import cmsConfig from "../../redux/helpers/cmsConfig";
import { Link } from "react-router-dom";

export const Footer = (props) => {
  return (
    <footer>
      <Container className="footer fixed-bottom" fluid>
        <Row className="footerRow">
          <Col lg={10} md={8} className="leftFooter">
            <span className="-TPT-Retirement-Sol copyright-hide">
              {props?.footerContent?.properties?.footerCopyrightText}
            </span>
            <Row className="footer-links mt-3">
              <Col className="footer-links-left">
                {props?.footerContent?.properties?.footerLinks?.map(
                  (item, index) => {
                    let route = null;
                    if (item?.url === null) {
                      route = item?.route?.path;
                    } else if (item?.url.includes("http")) {
                      route = item.url;
                    } else {
                      route = item.url;
                    }
                    return (
                      <span
                        key={index}
                        className="terms-conditions footer-link-items-left TypographyComponentsButtonsPrimary-Secondary-ButtonsButton-Large-Tablet-2 me-5"
                      >
                        {item?.target ? (
                          <Link
                            to={route}
                            target="_blank"
                            rel="noreferrer"
                            className="footer-items-link"
                          >
                            {item?.title}
                          </Link>
                        ) : (
                          <Link
                            to={route}
                            rel="noreferrer"
                            className="footer-items-link"
                          >
                            {item?.title}
                          </Link>
                        )}
                      </span>
                    );
                  } //eslint-disable-line
                )}
              </Col>
            </Row>
          </Col>
          <Col lg={2} md={4} className="centeralign-icons">
            <Row className="row-icons-mobile">
              {props?.footerContent?.properties?.footerLogo?.items?.map(
                (item, index) => {
                  return (
                    <Col key={index} lg={6} md={6} sm={6} xs={6}>
                      <div>
                        <img
                          alt={item?.content?.properties?.alternateTextSingle}
                          src={`${cmsConfig?.baseUrl}${item?.content?.properties?.image[0]?.url}`}
                          className="logo-tptCyberEssentialsLogo"
                        />
                      </div>
                    </Col>
                  );
                } //eslint-disable-line
              )}
            </Row>
          </Col>
          <span className="-TPT-Retirement-Sol copyright-hide-mobile">
            {props?.footerContent?.properties?.footerCopyrightText}
          </span>
        </Row>
      </Container>
    </footer>
  );
};
